import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './CallsView.scss';

import Calls from '../components/Calls/Calls';
import Call from '../components/Call/Call';

const CallsView = (props) => {
  const { calls, user, deals, getAllDeals, updateChatParticipant } = props;
  const { visibleCall } = calls || {};
  const callId = parseInt(_.get(props, 'match.params.id'));
  const callHash = _.get(props, 'match.params.hash');
  return (
    <div className='calls-view-outer-container'>
      {callId || callHash ? (
        <Call call={visibleCall} callId={callId} callHash={callHash} updateCall={props.updateCall} getCall={props.getCall} />
      ) : (
        <Calls
          updateChatParticipant={updateChatParticipant}
          user={user}
          deals={deals}
          getAllDeals={getAllDeals}
          deleteCall={props.deleteCall}
          getAllCalls={props.getAllCalls}
          getKeyMomentTypes={props.getKeyMomentTypes}
          calls={calls}
        />
      )}
    </div>
  );
};

CallsView.propTypes = {
  ui: PropTypes.object.isRequired,
  calls: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  getAllCalls: PropTypes.func.isRequired,
  getCall: PropTypes.func.isRequired,
  updateCall: PropTypes.func.isRequired,
  deleteCall: PropTypes.func.isRequired,
  getKeyMomentTypes: PropTypes.func.isRequired,
  updateChatParticipant: PropTypes.func.isRequired,
};

export default withRouter(CallsView);
